import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch } from '../../../../../utils';
import axios from 'axios';
import { BASE_URL } from '../../../../../utils';

const TABLE_HEADER = [
  {
    header: 'Service Name',
    accessor: (row) => row?.testData?.test_name
  }
];


export const LabBillingDetailform = ({ onClose, onAdd ,sponsorId,
   patientType, 
   editData,
   isEditMode
  }) => {
  const [serviceDropdown, setServiceDropdown] = useState([])
  const [uhidInput, setUhidInput] = useState('');


  const getTestDropdown = useCallback(async () => {
    const response = await axios.get(`${BASE_URL}/lab-price-list-master/list?&sponsorName=${sponsorId}`);
    setServiceDropdown(response.data.data);
  }, [sponsorId]);

  useEffect(() => {
 
    getTestDropdown();
  }, [sponsorId]);


  const getTestDropdownn = useCallback(async () => {
    const response = await axios.get(`${BASE_URL}/lab-price-list-master/list?&sponsorName=${sponsorId}&testName=${uhidInput}`);
    setServiceDropdown(response.data.data);
  }, [sponsorId,uhidInput]);


  useEffect(() => {
      getTestDropdownn();
  }, [uhidInput]);

  const handleChange = (e) => {
    const newInput = e.target.value;
    setUhidInput(newInput);
  };

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        service: Yup.string().required('Please select Service')
      })
    ),
    defaultValues: {
      service: '',
      quantity: 1,
      rate: 0,
      amount: 0,
      net_amt: 0,
      gst_amt: 0,
      disc_amt: 0,
      disc_per: 0,
      gst_per: 0
    },
    mode: 'all'
  });

  const { handleSubmit, setValue, watch, reset } = methods;

  const formSubmitHandler = (formValues) => {
    formValues.gst_per = +formValues.gst_per;
    formValues.disc_per = +formValues.disc_per;
    formValues.quantity = +formValues.quantity;
    const transformedValues = {
      ...formValues,
    };
    console.log(transformedValues,"TRNAFORMED VALUES IS HERE")
    if (isEditMode && editData) {
      transformedValues.service = formValues.service; 
      onAdd(transformedValues, true); 
    } else {
      onAdd(transformedValues, false);
    }
  };

  const handleServiceSelection = (row) => {
    if(patientType === "IPD"){
      setValue('rate', row?.inputValues[0]['Ipd Charge'] || 0);
    }else{
      setValue('rate', row?.inputValues[0]['OPD Charge'] || 0);
    }
    setValue('serviceName',  row?.testData?.test_name);
    setValue('service',  row?.testData?._id);
  };

  const rateWatch = watch('rate');
  const quantityWatch = watch('quantity');
  const discPerWatch = watch('disc_per');
  const gstPerWatch = watch('gst_per');
  const discAmtWatch = watch('disc_amt');

  useEffect(() => {
    const amount = rateWatch * quantityWatch;
    const discAmt = (amount * discPerWatch) / 100;
    const gstAmt = ((amount - discAmt) * gstPerWatch) / 100;
    const netAmt = amount - discAmt + gstAmt;
    setValue('amount', amount);
    setValue('disc_amt', discAmt);
    setValue('gst_amt', gstAmt);
    setValue('net_amt', netAmt);
  }, [rateWatch, quantityWatch, discPerWatch, gstPerWatch, setValue]);


  useEffect(() => {
    if (rateWatch && quantityWatch && discAmtWatch !== undefined) {
      const amount = rateWatch * quantityWatch;
      const newDiscPer = (discAmtWatch / amount) * 100;
      setValue('disc_per', newDiscPer);
    }
  }, [rateWatch, quantityWatch, discAmtWatch, setValue]);



  useEffect(() => {
    if (isEditMode && editData) {
     setValue('serviceName',editData?.serviceName)
     setValue('rate',editData?.rate)
     setValue('net_amt',editData?.net_amt)
     setValue('_id',editData?._id)
    } else {
      reset();
    }
  }, [isEditMode, editData, reset,discAmtWatch]);


  return (
    <Stack spacing={1} sx={{ height: '100%' }}>
      <Stack
        padding={0}
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Add Billing Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
        <MuiTextField
          sx={{ width: '100%', padding: 0 }}
          label="Search Test"
          variant="outlined"
          value={uhidInput}
          inputProps={{
            style: {
              fontSize: '16px',
              fontWeight: 700
            }
          }}
          onChange={handleChange}
        />
      </Stack>
      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
          <Grid
            item
            xs={6}
            sx={{
              height: '100%',
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 1
            }}
          >
            <Table
              containerSX={{ flex: 1, height: '100%', overflow: 'auto' }}
              size="small"
              data={serviceDropdown || []}
              columns={TABLE_HEADER}
              onRowClick={handleServiceSelection}
            />
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.4, px: 2 }}>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.2, fontSize: '1.2rem', fontWeight: 700 }}>Service</Typography>
                <TextField sx={{ flex: 0.8 }} disabled name="serviceName" placeholder="Select Service" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.2, fontSize: '1.2rem', fontWeight: 700 }}>Quantity</Typography>
                <TextField
                  sx={{ flex: 0.3 }}
                  type="number"
                  inputProps={{ min: '0' }}
                  name="quantity"
                  placeholder="Quantity"
                />
                <Typography sx={{ flex: 0.15, fontSize: '1.2rem', fontWeight: 700 }}>Rate</Typography>
                <TextField sx={{ flex: 0.35 }}  name="rate" placeholder="Rate" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.2, fontSize: '1.2rem', fontWeight: 700 }}>Amount</Typography>
                <TextField sx={{ flex: 0.8 }} name="amount" disabled placeholder="amount" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.2, fontSize: '1.2rem', fontWeight: 700 }}>Disc. Auth</Typography>
                <TextField sx={{ flex: 0.8 }} name="disc_auth" placeholder="Select Disc. Auth" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.2, fontSize: '1.2rem', fontWeight: 700 }}>Disc. Type</Typography>
                <TextField sx={{ flex: 0.8 }} name="disc_type" placeholder="Disc. Type" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.2, fontSize: '1.2rem', fontWeight: 700 }}>Disc. Per</Typography>
                <TextField
                  sx={{ flex: 0.3 }}
                  name="disc_per"
                  type="number"
                  inputProps={{ min: '0', max: '100' }}
                  placeholder="Disc. Per"
                />
                <Typography sx={{ flex: 0.2, fontSize: '1.2rem', fontWeight: 700 }}>Disc. Amt</Typography>
                <TextField sx={{ flex: 0.3 }} name="disc_amt" type="number" placeholder="Disc. Amt" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.2, fontSize: '1.2rem', fontWeight: 700 }}>Net Amount</Typography>
                <TextField
                  sx={{ flex: 0.8 }}
                  name="net_amt"
                  type="number"
                  disabled
                  inputProps={{ min: '0' }}
                  placeholder="Net Amount"
                />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
                <Button variant="contained" type="submit">
                  Add
                </Button>
                <Button variant="outlined" onClick={onClose} color="error">
                  Close
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
